import React from 'react';
import { MembershipDistribution as MembershipDistributionType } from '../../../types/dashboard';

interface MembershipDistributionProps {
  distribution: MembershipDistributionType | null;
  isLoading?: boolean;
}

const MembershipDistribution: React.FC<MembershipDistributionProps> = ({ distribution, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
        <div className="h-5 bg-gray-800 rounded w-48 mb-4 animate-pulse" />
        <div className="space-y-4">
          <div className="h-16 bg-gray-800 rounded animate-pulse" />
          <div className="h-16 bg-gray-800 rounded animate-pulse" />
        </div>
      </div>
    );
  }

  const total = (distribution?.pro || 0) + (distribution?.trial || 0);
  const proPercentage = total > 0 ? ((distribution?.pro || 0) / total) * 100 : 0;
  const trialPercentage = total > 0 ? ((distribution?.trial || 0) / total) * 100 : 0;

  return (
    <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
      <h3 className="text-white text-lg font-semibold mb-4">Membership Distribution</h3>
      
      <div className="space-y-4">
        {/* Pro Members */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-gray-400 text-sm">Pro Members</span>
            <span className="text-white font-semibold">
              {distribution?.pro || 0} ({proPercentage.toFixed(1)}%)
            </span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-2">
            <div 
              className="bg-[#23F47C] h-2 rounded-full transition-all duration-500"
              style={{ width: `${proPercentage}%` }}
            />
          </div>
        </div>

        {/* Trial Members */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-gray-400 text-sm">Trial Members</span>
            <span className="text-white font-semibold">
              {distribution?.trial || 0} ({trialPercentage.toFixed(1)}%)
            </span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-2">
            <div 
              className="bg-blue-500 h-2 rounded-full transition-all duration-500"
              style={{ width: `${trialPercentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipDistribution;
